<template>
  <v-card
    id="tickets-card"
    class="max-shadow"
  >
    <v-card-title class="py-2">
      <div class="title-2">
        Tickets
      </div>
      <v-spacer />
      <v-menu offset-y>
        <template v-slot:activator="{ on }">
          <v-btn
            depressed
            v-on="on"
          >
            {{ category.title }}
            <v-icon class="pl-2">
              arrow_drop_down
            </v-icon>
          </v-btn>
        </template>
        <v-list dense>
          <v-list-tile
            v-for="id in Object.keys(categoryList)"
            :key="id"
            @click="updateCategory(id, categoryList[id])"
          >
            <v-list-tile-title>{{ categoryList[id].title }}</v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu>
      <v-menu offset-y>
        <template v-slot:activator="{ on }">
          <v-btn
            depressed
            v-on="on"
          >
            {{ filterBy }}
            <v-icon class="pl-2">
              arrow_drop_down
            </v-icon>
          </v-btn>
        </template>
        <v-list dense>
          <v-list-tile
            v-for="(date, index) in dateRange"
            :key="index"
            @click="updateDate(date)"
          >
            <v-list-tile-title>{{ date }}</v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu>
    </v-card-title>
    <v-divider />
    <div class="tickets-widget px-1 scroll-y">
      <v-layout
        row
        wrap
        class="pt-2 pb-1"
      >
        <v-flex
          xs12
          sm6
        >
          <count-widget
            color="pink darken-1"
            icon="mdi-ticket-outline"
            title="Open Tickets"
            :value="openTickets"
            style="max-width: 300px; margin: 0 auto"
          />
        </v-flex>
        <v-flex
          xs12
          sm6
        >
          <count-widget
            color="orange darken-2"
            icon="mdi-ticket-outline"
            title="Closed Tickets"
            :value="closedTickets"
            style="max-width: 300px; margin: 0 auto"
          />
        </v-flex>
      </v-layout>
      <v-layout
        row
        wrap
        class="pt-2 pb-1"
      >
        <v-flex
          xs12
          sm6
        >
          <count-widget
            color="orange darken-2"
            icon="mdi-ticket-outline"
            title="Re-opened Tickets"
            :value="reopenedTickets"
            style="max-width: 300px; margin: 0 auto"
          />
        </v-flex>
        <v-flex
          xs12
          sm6
        >
          <count-widget
            color="pink darken-1"
            icon="mdi-ticket-outline"
            title="Total Tickets"
            :value="totalTickets.length"
            style="max-width: 300px; margin: 0 auto"
          />
        </v-flex>
      </v-layout>
      <!-- <div xs12 sm6>
        <iframe
          class="frame"
          height="450"
          src="https://datastudio.google.com/embed/reporting/1jGZwkzgNp3UVRCTYehoGXvEzT9lm2eCe/page/Knm6"
          frameborder="0"
          style="border:0"
          allowfullscreen
        ></iframe>
      </div> -->
      <v-subheader v-if="categoryMostTickets">
        Category Generating Most Tickets:&nbsp;
        <span>{{ categoryList[categoryMostTickets.id].title }}</span>
        ,&nbsp;
        <span>{{ categoryMostTickets.count }} ticket{{ categoryMostTickets.count >= 1 ? 's': '' }}</span>
      </v-subheader>
      <v-subheader>
        Average Time to Close Ticket (only closed):&nbsp;
        <span>{{ averageTAT }}</span>
      </v-subheader>
      <v-subheader>Recently opened</v-subheader>
      <v-divider />
      <div style="height: calc(100vh - 385px); overflow-y: scroll">
        <div
          v-for="ticket in recentTickets"
          :key="ticket.id"
        >
          <v-flex xs12>
            <ticket-tile :ticket="ticket" />
          </v-flex>
        </div>
      </div>
    </div>
    <v-snackbar
      v-model="snackbar"
      :color="snackColor"
      :timeout="0"
      bottom
    >
      {{ snackbarMessage }}
      <v-btn
        flat
        @click.native="snackbar = false"
      >
        Close
      </v-btn>
    </v-snackbar>
  </v-card>
</template>
<script>
import TicketCountwidget from '@/components/common/TicketCountWidget';
import TicketTile from '@/components/common/TicketTile';

import { firestore } from '@/firebase';
import * as moment from 'moment';
import _get from 'lodash/get';
export default {
  components: {
    'ticket-tile': TicketTile,
    'count-widget': TicketCountwidget
  },
  data() {
    return {
      totalTickets: [],
      recentTickets: [],

      startAt: '',
      endAt: '',

      snackbar: false,
      snackColor: 'primary',
      snackbarMessage: '',
      dateRange: [
        'Today',
        'Yesterday',
        'This Week',
        'This Month',
        'Last 30 days',
        'This Year'
      ],
      filterBy: 'Today',
      category: { title: 'Select Category', id: 'all' },
      categoryList: {}
    };
  },

  computed: {
    role() {
      return _get(this.$store.state.profile, 'role');
    },
    cid() {
      return _get(this.$store.state.profile, 'cid');
    },
    openTickets() {
      return this.totalTickets.filter(ticket => ticket.status === 'open')
        .length;
    },
    closedTickets() {
      return this.totalTickets.filter(ticket => ticket.status === 'closed')
        .length;
    },
    reopenedTickets() {
      return this.totalTickets.filter(ticket => ticket.status === 'reopened')
        .length;
    },
    ticketRef() {
      return this.role === 'admin'
        ? firestore.doc(`helpDesk/${this.cid}`).collection('tickets')
        : firestore.doc('helpDesk/buildingSupport').collection('tickets');
    },
    averageTAT() {
      if (this.totalTickets.length <= 0) return '0.0';
      if (this.closedTickets <= 0) return '0.0';

      let duration = 0;
      for (const index in this.totalTickets) {
        const { createdAt } = this.totalTickets[index];
        const { closedAt } = this.totalTickets[index];
        if (closedAt) {
          const createdDate = createdAt.toDate();
          const closedDate = closedAt.toDate();
          duration += moment(closedDate).diff(moment(createdDate), 'hours');
        }
      }

      const inhours = (duration / this.closedTickets).toFixed(2);
      if (inhours < 48) {
        if (inhours <= 1) return `${inhours} hours`;
        return `${inhours} hours`;
      }

      return `${(inhours / 24).toFixed(2)} days`;
    },
    categoryMostTickets() {
      if (
        this.totalTickets.length <= 0 ||
        this.categoryList.length <= 0 ||
        this.category.id != 'all'
      )
        return null;

      let categoryId = null;
      let count = -1;
      let categories = Object.assign({}, this.categoryList);

      for (const index in this.totalTickets) {
        const ticket = this.totalTickets[index];
        if (!categories[ticket.categoryId]) continue;

        if (!categories[ticket.categoryId].count)
          categories[ticket.categoryId].count = 0;

        categories[ticket.categoryId].count++;

        if (count < categories[ticket.categoryId].count) {
          count = categories[ticket.categoryId].count;
          categoryId = ticket.categoryId;
        }
      }

      Object.keys(categories).forEach(function(key) {
        categories[key].count = 0;
      });

      return { id: categoryId, count: count };
    }
  },
  watch: {
    role: {
      handler(val) {
        if (!val) return;
        this.startAt = moment()
          .startOf('day')
          .valueOf();
        this.endAt = moment()
          .endOf('day')
          .valueOf();
        this.fetchData();

        this.ticketRef
          .orderBy('createdAt', 'desc')
          .where('status', '==', 'open')
          .limit(3)
          .get()
          .then(tickets => {
            const docs = [];
            tickets.forEach(docSnapshot => {
              docs.push({ ...docSnapshot.data(), ...{ id: docSnapshot.id } });
            });
            this.recentTickets = docs;
            // console.log(docs, fetchTodays);
          });
      },
      immediate: true
    }
  },
  mounted() {
    if (this.role == 'admin') {
      firestore
        .doc(`helpDesk/${this.cid}`)
        .get()
        .then(snapshot => {
          const docData = (snapshot.data() || {}).categories || {};

          this.categoryList = docData;
          this.categoryList.all = { title: 'All', id: 'all' };
        });
    } else if (this.role == 'max-admin') {
      firestore
        .doc(`helpDesk/buildingSupport`)
        .get()
        .then(snapshot => {
          const docData = (snapshot.data() || {}).categories || {};

          this.categoryList = docData;
          this.categoryList.all = { title: 'All', id: 'all' };
        });
    }
  },
  methods: {
    formatTime(timestamp) {
      const date = timestamp.toDate();
      const today = moment().startOf('day');
      return moment(date).isAfter(today)
        ? moment(date).fromNow()
        : moment(date).calendar(today, {
            lastWeek: 'D MMM [at] hh:mm A',
            sameElse: 'D MMM [at] hh:mm A'
          });
    },
    fetchData() {
      (this.category.id == null || this.category.id === 'all'
        ? this.ticketRef
            .orderBy('createdAt')
            .startAt(new Date(this.startAt))
            .endAt(new Date(this.endAt))
        : this.ticketRef
            .orderBy('createdAt')
            .startAt(new Date(this.startAt))
            .endAt(new Date(this.endAt))
            .where('categoryId', '==', this.category.id)
      )
        .get()
        .then(tickets => {
          const docs = [];
          tickets.forEach(docSnapshot => {
            docs.push({ ...docSnapshot.data(), ...{ id: docSnapshot.id } });
          });
          this.totalTickets = docs;
          // console.log(docs, fetchTodays);
        });
    },
    updateWidgets() {
      switch (this.filterBy) {
        case 'Today':
          this.startAt = moment()
            .startOf('day')
            .valueOf();
          this.endAt = moment()
            .endOf('day')
            .valueOf();
          this.fetchData();
          break;

        case 'Yesterday':
          this.startAt = moment()
            .subtract(1, 'days')
            .startOf('day')
            .valueOf();
          this.endAt = moment()
            .subtract(1, 'days')
            .endOf('day')
            .valueOf();
          this.fetchData();
          break;

        case 'This Week':
          this.startAt = moment()
            .startOf('week')
            .valueOf();
          this.endAt = moment()
            .endOf('day')
            .valueOf();
          this.fetchData();

          break;

        case 'This Month':
          this.startAt = moment()
            .startOf('month')
            .valueOf();
          this.endAt = moment()
            .endOf('day')
            .valueOf();
          this.fetchData();

          break;

        case 'Last 30 days':
          this.startAt = moment()
            .subtract(29, 'days')
            .startOf('day')
            .valueOf();
          this.endAt = moment()
            .endOf('day')
            .valueOf();
          this.fetchData();

          break;

        case 'This Year':
          this.startAt = moment()
            .startOf('year')
            .valueOf();
          this.endAt = moment()
            .endOf('day')
            .valueOf();
          this.fetchData();

          break;

        default:
          break;
      }
    },
    updateCategory(id, value) {
      if (this.category.id === id && this.category.title === value.title)
        return;
      value.id = id;

      this.category = value;
      this.updateWidgets();
    },
    updateDate(date) {
      if (this.filterBy === date) return;

      this.filterBy = date;
      this.updateWidgets();
    }
  }
};
</script>
<style>
#tickets-card {
  height: calc(100vh - 158px);
}
.tickets-widget {
  height: calc(100vh - 238px);
}
.frame {
  display: inline-block;
  width: 100vw;
  max-width: 100%;
  margin: 0;
  padding: 0;
  border: 0 none;
  box-sizing: border-box;
}
</style>
